import axios from 'axios';
import { AnalyticsData } from '../types';
import config from '../config';

const BACKEND_URL = config.api.url;
const API_BASE_URL = `${BACKEND_URL}/api/analytics`;

// Créer une instance axios avec les configurations par défaut
const analyticsApi = axios.create({
  baseURL: API_BASE_URL,
  timeout: config.api.timeout,
});

// Intercepteur pour ajouter automatiquement le token JWT
analyticsApi.interceptors.request.use((config) => {
  const token = localStorage.getItem('authToken');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const getAnalytics = async (): Promise<AnalyticsData> => {
  const response = await analyticsApi.get('/');
  return response.data;
};

export const getDashboardMetrics = async (): Promise<AnalyticsData> => {
  const response = await analyticsApi.get('/dashboard');
  return response.data;
};

export const getRealtimeStats = async (): Promise<any> => {
  const response = await analyticsApi.get('/realtime');
  return response.data;
};
